function initTrustCarousels() {
  document.querySelectorAll('[data-trust-carousel]').forEach((root) => {
    if (root.dataset.ready) return;
    const list = root.querySelector('.trust-strip__list');
    if (!list || list.children.length < 3) return;
    root.dataset.ready = 'true';
    const originals = Array.from(list.children);
    const clones = originals.map((item) => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('inert', '');
      clone.removeAttribute('id');
      clone.removeAttribute('data-shopify-editor-block');
      clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
      clone.hidden = true;
      list.append(clone);
      return clone;
    });
    const mobile = matchMedia('(max-width: 767px)');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let frame;
    let previous = 0;
    let position = 0;
    let distance = 0;
    let visible = true;
    let focused = false;
    const tick = (time) => {
      if (!root.isConnected) return;
      if (previous && distance) position = (position + Math.min(time - previous, 64) * 0.022) % distance;
      previous = time;
      list.style.transform = `translate3d(${-position}px, 0, 0)`;
      frame = requestAnimationFrame(tick);
    };
    const update = () => {
      cancelAnimationFrame(frame);
      previous = 0;
      const enabled = mobile.matches && !reduced.matches && !focused;
      root.dataset.moving = String(enabled);
      clones.forEach((clone) => { clone.hidden = !enabled; });
      if (!enabled) {
        position = 0;
        list.style.transform = '';
        return;
      }
      list.scrollLeft = 0;
      distance = clones[0].offsetLeft - originals[0].offsetLeft;
      if (distance) position %= distance;
      if (visible && !document.hidden) frame = requestAnimationFrame(tick);
    };
    list.addEventListener('focusin', () => { focused = true; update(); });
    list.addEventListener('focusout', (event) => {
      if (!list.contains(event.relatedTarget)) { focused = false; update(); }
    });
    mobile.addEventListener('change', update);
    reduced.addEventListener('change', update);
    document.addEventListener('visibilitychange', update);
    const resize = new ResizeObserver(update);
    resize.observe(root);
    const intersection = new IntersectionObserver(([entry]) => {
      visible = entry.isIntersecting;
      update();
    });
    intersection.observe(root);
    root.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
      cancelAnimationFrame(frame);
      resize.disconnect();
      intersection.disconnect();
      mobile.removeEventListener('change', update);
      reduced.removeEventListener('change', update);
      document.removeEventListener('visibilitychange', update);
    }, { once: true });
    update();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTrustCarousels, { once: true });
else initTrustCarousels();
document.addEventListener('shopify:section:load', initTrustCarousels);
